export const scrollToTop = () => {
  setTimeout(() => {
    const modal = document.querySelector('[role="presentation"]')
    if (modal) {
      const scrollableElement = Array.from(modal.querySelectorAll('*')).find((el) => {
        const style = window.getComputedStyle(el as HTMLElement)
        return style.overflowY === 'auto' || style.overflowY === 'scroll'
      }) as HTMLElement

      if (scrollableElement) {
        scrollableElement.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }, 100)
}
